<br />
<mat-tab-group (selectedTabChange)="tabChange($event)" [selectedIndex]="selectedTabIndex" #tabGroup>
  <!-- <mat-tab-group [selectedIndex]="getActiveIndex() | async"> -->
  <ng-container *ngFor="let mortgage of mortgageList; let i = index">
    <mat-tab>
      <ng-template mat-tab-label (click)="activeMortgageValue(mortgage)"
        ><p>Mortgage {{ i + 1 }}</p>
      </ng-template>
    </mat-tab>
  </ng-container>
</mat-tab-group>

<div class="row mx-0 my-4 extra-payment">
  <div class="col-lg-3 col-sm-12 col-12 px-4">
    <mat-slider
      (input)="onSliderChange($event)"
      class="w-100 mb-0 mt-4"
      thumbLabel
      [(ngModel)]="extraPaymentChange"
      aria-label="units"
      name="closeByYears"
      step="10"
      min="0"
      max="300"
    ></mat-slider>
    <div class="d-flex mb-4">
      <span class="value-start">$0</span>
      <span class="value-mid">$50</span>
      <span class="value-mid">$100</span>
      <span class="value-mid">$150</span>
      <span class="value-mid">$200</span>
      <span class="value-mid">$250</span>
      <span class="value-end">$300</span>
    </div>
    <form [formGroup]="extraPaymentForm">
      <mat-form-field class="principal mt-4 w-100">
        <input
          class="text-left"
          matInput
          placeholder="Principal"
          currencyMask
          [(ngModel)]="extraPaymentChange"
          formControlName="extraPayment"
          autocomplete="off"
        />
        <span matPrefix>$ &nbsp;</span>
      </mat-form-field>
      <mat-error>{{ extraMoreThenBalanceError }}</mat-error>
    </form>
  </div>
  <div class="col-lg-1">&nbsp;</div>
  <div class="col-lg-3 col-sm-6 col-12">
    <div class="row terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Date.png" width="26" />
      </div>
      <div class="col-md-10 col-10">
        <label>Payoff Date</label>
        <h4 class="mb-0">{{ payoffDate | date }}</h4>
      </div>
    </div>
    <div class="row mt-4 terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Term.png" width="26" />
      </div>
      <div class="col-md-10 col-10">
        <label>Remaining Term</label>
        <h4 class="mb-0">{{ remainingTeam }} Months</h4>
      </div>
    </div>
    <div class="row mt-4 terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Interest.png" width="26" />
      </div>
      <div class="col-md-10 col-10">
        <label>Total Interest</label>
        <h4 class="mb-0">{{ totalInterest | currency: 'USD':'symbol':'0.0-0' }}</h4>
      </div>
    </div>
  </div>
  <div class="col-lg-1">&nbsp;</div>
  <div class="col-lg-3 col-sm-6 col-12">
    <div class="row terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Date.png" width="26" />
      </div>
      <div class="col-md-8 col-8">
        <label>New Payoff Date</label>
        <h4 class="mb-0">{{ newPayoffDate | date }}</h4>
      </div>
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 text-center" src="../../../assets/images/up.svg" width="18" />
      </div>
    </div>
    <div class="row mt-4 terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Loan.png" width="26" />
      </div>
      <div class="col-md-8 col-8">
        <label>Shorten the Loan by</label>
        <h4 class="mb-0">{{ saveMonth }} Months</h4>
      </div>
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 text-center" src="../../../assets/images/up.svg" width="18" />
      </div>
    </div>
    <div class="row mt-4 terms">
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 float-right" src="../../../assets/images/Prop-Saving.png" width="26" />
      </div>
      <div class="col-md-8 col-8">
        <label>Interest Savings</label>
        <h4 class="mb-0">{{ saveAmount | currency: 'USD':'symbol':'0.0-0' }}</h4>
      </div>
      <div class="col-md-2 col-2 pr-0">
        <img class="mt-2 text-center" src="../../../assets/images/up.svg" width="18" />
      </div>
    </div>
  </div>
  <div class="col-lg-1">&nbsp;</div>
</div>
